module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門2_4_4.dbab5ca4.png";